import { render, staticRenderFns } from "./CustomerPreferences.vue?vue&type=template&id=0a02d493&scoped=true"
import script from "./CustomerPreferences.vue?vue&type=script&lang=js"
export * from "./CustomerPreferences.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CustomerPreferences.vue?vue&type=style&index=1&id=0a02d493&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a02d493",
  null
  
)

export default component.exports